
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import 'react-dropdown-tree-select/dist/styles.css';
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
// Material Dashboard 2 React example components
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import axios from "axios";
import { useForm } from 'react-hook-form';
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CircularProgress, Backdrop } from "@mui/material";
import Config from "../../config.js";
import { useTranslation } from "react-i18next";
import { Select, MenuItem, FormControl } from '@mui/material';
import DropdownTreeSelect from 'react-dropdown-tree-select';
import 'react-dropdown-tree-select/dist/styles.css';
import DeleteIcon from '@mui/icons-material/Delete';
import { handleErrors } from "common.js";
import { CUSTOM_FIELD } from "constants.js";

function AddCustomField(props) {

  const type = props.props.type;
  const { t } = useTranslation();
  const BASE = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const [categoryHierarchy, setCategoryHierarchy] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [fieldType, setFieldType] = useState(1);
  const [mandatory, setChecked] = useState(false);
  const [showOnShop, setShowOnShop] = useState(false);
  const [category, setCategory] = useState(0);
  const [dropdownOptions, setDropdownOptions] = useState([{ "option": "", "tagName": "" }]);
  const [fileTypeSize, setFileTypeSize] = useState({ "type": "", "fileSize": "" });

  const convertToTree = (data) => {
    const treeData = [];
    data.forEach((node) => {
      if (node) {
        let tempArrayNew = {};
        tempArrayNew.label = node.name;
        tempArrayNew.value = node.id;
        treeData.push(tempArrayNew);
      }
    });
    return treeData;
  };

  const setCategoryData = (currentNode, selectedNodes) => {
    setCategoryHierarchy((pre) => {
      let preData = pre;
      let selectedCategory = selectedNodes[0].value;
      setCategory(selectedNodes[0].value);
      preData.forEach((item, index) => {
        if (item.value === selectedCategory) {
          // Update the value for the matching row
          preData[index].checked = selectedNodes[0].checked;
          preData[index].hide = selectedNodes[0].hide;
          preData[index]._focused = selectedNodes[0]._focused;
          preData[index]._depth = selectedNodes[0]._depth;
          preData[index]._id = selectedNodes[0]._id;
        }
      });
      return preData;
    });
  };

  const { register, handleSubmit, setValue, setError, formState: { errors } } = useForm();

  const manipulateDataForDefaultSelected = (nodes, parentID) => {
    nodes.forEach((node) => {
      if (node.value == parentID) {
        node.checked = true;
        node.partialChecked = false;
      }
      if (node.children && node.children.length > 0) {
        manipulateDataForDefaultSelected(node.children, parentID);
      }
    });
  };

  const getHierarchy = (parentID = 0) => {
    setIsLoading(true);
    axios({
      // Endpoint to send files
      url: BASE + "api/category/getHierarchy/" + type,
      method: "GET",
      headers: {
        // Add any auth token here
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
    }).then(function (response) {
      setIsLoading(false);
      const requestStatus = response.status;
      if (requestStatus == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          const convertedData = convertToTree(response.data.data);
          setCategoryHierarchy(convertedData);
        }
        else {
          toast.error(t(message));
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch(function (error) {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  };

  useEffect(() => {
    if (type == CUSTOM_FIELD.PRODUCT || type == CUSTOM_FIELD.SERVICE)
      getHierarchy();
  }, []);

  const onSubmit = async (data) => {
    setIsLoading(true);
    data.type = type;
    data.mandatory = (mandatory) ? 1 : 0;
    data.showOnShop = (showOnShop) ? 1 : 0;
    data.additionalInfo = JSON.stringify(fileTypeSize);
    data.values = JSON.stringify(dropdownOptions);
    data.categoryId = category;
    data.fieldType = fieldType;
    axios({
      url: BASE + "api/custom/create",
      method: "POST",
      data: data,
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
      // Attaching the form data
    }).then(function (response) {
      setIsLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          toast.success(t(message))
          const redirectTimeout = setTimeout(() => {
            clearTimeout(redirectTimeout);
            (type == CUSTOM_FIELD.PRODUCT) ? navigate("/productCustomfield/manage") : (type == CUSTOM_FIELD.SERVICE) ? navigate("/serviceCustomfield/manage") : (type == CUSTOM_FIELD.VENDOR) ? navigate("/vendorCustomfield/manage") : null;
          }, 3000);
        }
        else {
          if (message != '')
            toast.error(t(message))
          if (response && response.data && response.data.errors) {
            const errorData = response.data.errors;
            errorData.forEach((error) => {
              setError(error.field, {
                type: 'server',
                message: t(error.errors[0])
              });
            });
          }
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch(function (error) {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  };

  useEffect(() => {
  }, [dropdownOptions]);

  const handleOnclick = (index) => {
    let dropdownOptionsa = [...dropdownOptions];
    dropdownOptionsa.splice(index, 1);
    setDropdownOptions(dropdownOptionsa)
  }

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={(type == CUSTOM_FIELD.PRODUCT) ? t('add product customfield') : (type == CUSTOM_FIELD.SERVICE) ? t('add service customfield') : (type == CUSTOM_FIELD.VENDOR) ? t('add vendor customfield') : null} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading} >
        <CircularProgress color="inherit" />
      </Backdrop>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              {(categoryHierarchy) ?
                <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
                  <MDBox px={3}>
                    <Grid container spacing={2} mt={5}>
                      <Grid item xs={12} sm={4} md={4}>
                        <label className="labelCls">{t('fieldName')}</label>
                        <i className="mandatory">*</i>
                      </Grid>
                      <Grid item xs={12} sm={8} md={8}>
                        <MDInput type="text" name="fieldName" label="" {...register("fieldName",
                          {
                            required: true,
                            minLength: {
                              value: 3, // Minimum length required
                              message: t('Field name need at least 3 charectors'),
                            },
                            maxLength: {
                              value: 64, // Maximum length allowed
                              message: t("Field cannot exceed 64 characters"),
                            },
                          })} fullWidth />
                        {errors.fieldName && errors.fieldName.type === "required" && (
                          <p className="errorMsg">{t('fieldNameMandatory')}</p>
                        )}
                        {errors.fieldName && (
                          <p className="errorMsg">{errors.fieldName.message}</p>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                        <label className="labelCls">{t('displayName')}</label>
                        <i className="mandatory">*</i>
                      </Grid>
                      <Grid item xs={12} sm={8} md={8}>
                        <MDInput type="text" name="displayName" label="" {...register("displayName", { required: true })} fullWidth />
                        {errors.displayName && errors.displayName.type === "required" && (
                          <p className="errorMsg">{t('displayNameRequired')}</p>
                        )}
                        {errors.displayName && (
                          <p className="errorMsg">{errors.displayName.message}</p>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                        <label className="labelCls">{t('fieldType')}</label>
                        <i className="mandatory">*</i>
                      </Grid>
                      <Grid item xs={12} sm={8} md={8}>
                        <MDInput
                          select
                          name="fieldType"
                          value={fieldType}
                          InputProps={{
                            classes: { root: "filterStyle" },
                          }}
                          onChange={(obj) => {
                            setFieldType(obj.target.value);
                            setValue('fieldType', obj.target.value);
                            setValue('defaultValue', '');
                          }} fullWidth
                        >
                          <MenuItem value={1}>{t('text')}</MenuItem>
                          <MenuItem value={2}>{t('dropdown')}</MenuItem>
                          <MenuItem value={3}>{t('numeric')}</MenuItem>
                          <MenuItem value={4}>{t('date')}</MenuItem>
                          <MenuItem value={5}>{t('textarea')}</MenuItem>
                          <MenuItem value={6}>{t('multiselect')}</MenuItem>
                          <MenuItem value={7}>{t('file')}</MenuItem>
                        </MDInput>
                        {errors.fieldType && (
                          <p className="errorMsg">{errors.fieldType.message}</p>
                        )}
                      </Grid>
                      {(fieldType == CUSTOM_FIELD.DROPDOWN || fieldType == CUSTOM_FIELD.MULTISELECT) ?
                        <>
                          <Grid item xs={12} sm={4} md={4}>
                          </Grid>
                          <Grid item xs={12} sm={8} md={8}>
                            {
                              dropdownOptions.map((item, index) => {
                                return (
                                  <MDBox key={'ip_' + index}>
                                    <TextField className="customFieldOptions"
                                      key={'ipo_' + index} value={item.option} id="standard-basic" label={t('option')} variant="standard" onChange={(event) => {
                                        setDropdownOptions((pre) => {
                                          let newPre = [...pre];
                                          newPre[index].option = event.target.value;
                                          const hasEmptyOption = newPre.some(item => item.option === "");
                                          if (!hasEmptyOption) {
                                            newPre.push({
                                              "option": '',
                                              "tagName": ''
                                            });
                                          }
                                          return newPre;
                                        })
                                      }
                                      } />
                                    {(type != CUSTOM_FIELD.VENDOR) ?
                                      <TextField
                                        key={'iptag_' + index} value={item.tagName} id="standard-basic" label={t('tag')} variant="standard" onChange={(event) => {
                                          setDropdownOptions((pre) => {
                                            let newPre = [...pre];
                                            newPre[index].tagName = event.target.value;
                                            return newPre;
                                          })
                                        }
                                        } />
                                      : null
                                    }
                                    {(dropdownOptions[index].option != "") ?
                                      <Button
                                        onClick={() => {
                                          handleOnclick(index);
                                        }}>
                                        <DeleteIcon />
                                      </Button>
                                      : null}
                                  </MDBox>
                                )
                              })
                            }
                          </Grid>
                        </>
                        : null}
                      {(fieldType == CUSTOM_FIELD.FILE) ?
                        <>
                          <Grid item xs={12} sm={4} md={4}>
                          </Grid>
                          <Grid item xs={12} sm={8} md={8}>
                            <TextField value={fileTypeSize.type} id="types" className="customFieldOptions"
                              placeholder="Like png,jpeg"
                              label={t('file types')} variant="standard" onChange={(event) => {
                                setFileTypeSize((prevData) => ({
                                  ...prevData,
                                  type: event.target.value
                                }));
                              }} />
                            <TextField
                              placeholder="File size in KB, Example:50"
                              value={fileTypeSize.fileSize} id="sizes" label={t('file size')} variant="standard" onChange={(event) => {
                                setFileTypeSize((prevData) => ({
                                  ...prevData,
                                  fileSize: event.target.value
                                }));
                              }} />
                          </Grid>
                        </>
                        :
                        null
                      }
                      <Grid item xs={12} sm={4} md={4}>
                        <label className="labelCls">{t('defaultValue')}</label>
                      </Grid>
                      <Grid item xs={12} sm={8} md={8}>
                        <MDInput type={(fieldType == CUSTOM_FIELD.NUMERIC) ? 'number' : (fieldType === CUSTOM_FIELD.DATE) ? 'date' : 'text'} name="defaultValue" label="" {...register("defaultValue")} fullWidth />
                        {errors.defaultValue && (
                          <p className="errorMsg">{errors.defaultValue.message}</p>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                        <label className="labelCls">{t('is mandatory')}</label>
                      </Grid>
                      <Grid item xs={12} sm={8} md={8}>
                        <Checkbox
                          checked={mandatory}
                          onChange={(obj) => { setChecked(obj.target.checked) }}
                          name="mandatory"
                        />
                      </Grid>
                      {(type != CUSTOM_FIELD.VENDOR) ?
                        <>
                          <Grid item xs={12} sm={4} md={4}>
                            <label className="labelCls">{t('showOnShop')}</label>
                          </Grid>
                          <Grid item xs={12} sm={8} md={8}>
                            <Checkbox
                              checked={showOnShop}
                              onChange={(obj) => { setShowOnShop(obj.target.checked) }}
                              name="showOnShop"
                            />
                          </Grid>
                        </>
                        : null}
                      {(type != CUSTOM_FIELD.VENDOR) ?
                        <>
                          <Grid item xs={12} sm={4} md={4}>
                            <label className="labelCls">{t('select category')}</label>
                          </Grid>
                          <Grid item xs={12} sm={8} md={8}>
                            {(categoryHierarchy) ?
                              (
                                <DropdownTreeSelect
                                  data={categoryHierarchy}
                                  mode="radioSelect"
                                  texts={{ placeholder: 'Select category' }}
                                  onChange={setCategoryData}
                                />
                              )
                              : null}
                            {errors.categoryId && (
                              <p className="errorMsg">{t(errors.parentId.message)}</p>
                            )}
                          </Grid>
                        </>
                        : null}
                      <Grid item xs={12} sm={4} md={4}>
                      </Grid>
                      <Grid item xs={12} sm={8} md={8}>
                        <MDButton type="submit" variant="gradient" color="info" disableRipple>{t('Add')}</MDButton>
                      </Grid>
                    </Grid>
                  </MDBox>
                </MDBox>
                : null}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default AddCustomField;
